import React, { useState, useEffect } from "react";
import { Button, DatePicker, Input,Pagination } from "antd"; // Ant Design components
import { EditOutlined, DeleteOutlined, TaobaoSquareFilled } from "@ant-design/icons"; // Ant Design icons

import isBetween from "dayjs/plugin/isBetween"; // Import the isBetween plugin
import dayjs from "dayjs";
import { FaDownload, FaUpload } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { apiService } from "../services/apiService";
import Spinner from "./spinner";
import * as XLSX from "xlsx"; // Import xlsx library
import { toast } from "react-toastify";
const { RangePicker } = DatePicker; // RangePicker to select date range
 
dayjs.extend(isBetween);

// Sample Dynamic Column Data (could come from API)
const dynamicColumns = [
    { title: "Model", dataIndex: "model", width: 100, frozen: true },
    { title: "Item Type", dataIndex: "item_type", width: 90, frozen: true },
    { title: "Customer", dataIndex: "customer_name", width: 140, wrap: true, frozen: true },
    { title: "Category Code", dataIndex: "category_code", width: 120, wrap: true, frozen: true },
    { title: "Part Number", dataIndex: "part_number", width: 140, frozen: true },
    { title: "Order Number", dataIndex: "order_number",wrap: true,width:80  },
    { title: "Invoice Number", dataIndex: "invoice_number" ,wrap: true,width:100 },
    { title: "Invoice Date", dataIndex: "invoice_date",wrap: true },
    { title: "Unit Selling Price", dataIndex: "unit_selling_price" ,wrap: true,width:100 },
    // { title: "Invoice Amount Wo Gst", dataIndex: "invoice_amount_wo_gst" },
    // { title: "Gst Amount", dataIndex: "gst_amount" },
    { title: "Invoice Amount", dataIndex: "invoice_amount" ,wrap: true,width:110 },
    { title: "Invoice Currency Code", dataIndex: "invoice_currency_code", width: 90 ,wrap: true },
    // { title: "Cust Po Number", dataIndex: "cust_po_number" },
];



const ActualSales = ({ closeSidebar }) => {
    const [filteredData, setFilteredData] = useState([]); // Store filtered data
    const [editingKey, setEditingKey] = useState(null); // Store the key of the row being edited
    const [dates, setDates] = useState([null, null]);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]); // Store the actual sales data
    const [total, setTotal] = useState(0); // Store total number of records for pagination
    const [currentPage, setCurrentPage] = useState(1); // Store current page for pagination     
    const [pageSize, setPageSize] = useState(10); // Store page size for pagination
    const navigate = useNavigate();

    const frozenLeftMap = {};
    let leftOffset = 0;

    dynamicColumns.forEach(col => {
    if (col.frozen) {
        frozenLeftMap[col.dataIndex] = leftOffset;
        leftOffset += col.width || 0;
    }
    });


    //  const [loading, setLoading] = useState(false); // Track loading state
    // Fetch sales data on component mount
    const fetchSalesData = async (page,limit,startDate=null,endDate=null) => {
        setLoading(true); // Start loading
        try {
            const payload = {
                page,
                limit,
            };
    
            // Add date range to the payload if provided
            if (startDate && endDate) {
                payload.startDate = startDate;
                payload.endDate = endDate;
            }
            const response = await apiService(`actual-sales/get-records`, "POST",payload); // Replace with your API endpoint
            console.log("Fetched sales data:", response);
            setData(response.data.records); // Set the fetched data
            setFilteredData(response.data.records); // Initialize filtered data
            setTotal(response.data.pagination.total); // Set total number of records for pagination
     
        } catch (error) {
            console.error("Error fetching sales data:", error);

        } finally {
            setLoading(false); // Stop loading
        }
    };

    useEffect(() => {

      
        fetchSalesData(currentPage, pageSize); // Fetch sales data on component mount
    }, [currentPage, pageSize]); // Empty dependency array ensures this runs only once on mount
  // Handle page change
  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
};

const handleDateRangeChange = (dates) => {
    setDates(dates);

    
};
const handleSearch = () => {
    if (dates && dates.length === 2) {
        const [startDate, endDate] = dates.map((date) => date.format("YYYY-MM-DD")); // Format dates
        fetchSalesData(currentPage, pageSize, startDate, endDate); // Fetch data with date range
    } else {
        fetchSalesData(currentPage, pageSize); // Fetch data without date range
    }
};
    // Editable Cell component for editable cells in the table
    const EditableCellOld = ({ record, columnKey, ...restProps }) => {
        return (
            <td {...restProps}>
                {record.id === editingKey ? (
                    <Input
                        value={record[columnKey]}
                        onChange={(e) => {
                            const newData = [...filteredData];
                            const index = newData.findIndex((item) => item.id === record.id);
                            if (index > -1) {
                                newData[index][columnKey] = e.target.value;
                                setFilteredData(newData);
                            }
                        }}
                    />
                ) : (
                    <div>{record[columnKey]}</div>
                )}
            </td>
        );
    };
    const EditableCell = ({ record, columnKey }) => {
        const [error, setError] = useState(null);

        // Make 'model' and 'item_type' non-editable
        const isNonEditable = columnKey === "model" || columnKey === "item_type";

        const handleChange = (e) => {
            let newValue = e.target.value;

            // Validation for price fields
            if (
                columnKey === "unit_selling_price" ||
                columnKey === "invoice_amount"
            ) {
                if (isNaN(newValue) || newValue <= 0) {
                    setError('Please enter a valid price greater than 0');
                } else {
                    setError(null);
                }
            }

            // Update the value in filteredData directly
            const newData = [...filteredData];
            const index = newData.findIndex((item) => item.id === record.id);
            if (index > -1) {
                newData[index][columnKey] = newValue;
                setFilteredData(newData);
            }
        };

        if (record.id === editingKey) {
            if (isNonEditable) {
                return <div>{record[columnKey]}</div>;
            }
            return (
                <>
                    <Input
                        value={record[columnKey]}
                        onChange={handleChange}
                        style={{ borderColor: error ? 'red' : '' }}
                    />
                    {error && <div style={{ color: 'red', fontSize: '12px' }}>{error}</div>}
                </>
            );
        }
        return <div>{record[columnKey]}</div>;
    };
      
      
      
    const startEditing = (key) => { 
        console.log("Editing row:", key);

        setEditingKey(key); // Set the key for the row being edited
    };

    const cancelEditing = () => {
        setEditingKey(null); // Cancel editing by clearing the editing key
    };

    const deleteRow = (key) => {
        const newData = filteredData.filter((item) => item.id !== key);
        setFilteredData(newData); // Remove the row from the filtered data
    };

    const saveRow = async (key) => {
        const newData = [...filteredData];
        const index = newData.findIndex((item) => key === item.id);
      
        if (index > -1) {
          const row = newData[index];
          
          // Check if all price fields are valid (greater than 0)
          const requiredFields = ['unit_selling_price',  'invoice_amount'];
          const isValid = requiredFields.every((field) => row[field] > 0);
          const invalidFields = requiredFields.filter((field) => row[field] <= 0);
          console.log("Invalid fields:", invalidFields);

          if (!isValid) {
            invalidFields.forEach(field => {
                console.log(`Invalid field: ${field}, value:`, row[field]);
            });
            toast.error('All price fields must be greater than 0');
            return;  // Don't proceed if the validation fails
          }
      
          try {
            // Send updated row data to the backend
            const response = await apiService("actual-sales/update-record", "POST", row);
            if (response.data.success) {
              setFilteredData(newData); // Update the frontend data state
              setEditingKey(null); // Exit edit mode
              toast.success("Record updated successfully!");
            } else {
              toast.error("Failed to update record.");
            }
          } catch (error) {
            console.error("Error updating record:", error);
            toast.error("Failed to update record.");
          }
        }
      };
      

    // Dynamically generate the columns array
    const columns = [
        ...dynamicColumns,
        {
            title: "Action",
            dataIndex: "action",
            render: (_, record) => (
                <span>
                    {editingKey === record.id ? (
                        <span>
                            <Button onClick={() => saveRow(record.id)} style={{ marginRight: 8 }}>
                                Save
                            </Button>
                            <Button color="danger" onClick={cancelEditing}>Cancel</Button>
                        </span>
                    ) : (
                        <span>
                            <EditOutlined
                                onClick={
                                    () =>{ startEditing(record.id);
                                           closeSidebar?.()
                                    }
                                }
                                style={{ marginRight: 8, cursor: "pointer" }}
                            />
                            <DeleteOutlined
                                onClick={() => deleteRow(record.id)}
                                style={{ cursor: "pointer" }}
                            />
                        </span>
                    )}
                </span>
            ),
        },
    ];
    const handleExport = async () => {
        try {
            const payload = {};
            if (dates && dates.length === 2 && dates[0] && dates[1]) {
                const [startDate, endDate] = dates.map((date) => date.format("YYYY-MM-DD"));
                payload.startDate = startDate;
                payload.endDate = endDate;
            }

            const response = await apiService("actual-sales/get-all-records", "POST", payload);
            const allData = response.data.records;

            if (!allData || allData.length === 0) {
                alert("No data available to export.");
                return;
            }

           const excelHeaders = [
                            "Cust Name", "Ship To", "Freight Term", "Inv No", "Inv Date", "Order Type", "Country", "Customer Group", "Sub Group",
                            "Item Type", "Category", "Item Cat", "Item No", "Curr", "Sell Price", "Unit Price", "Unit Cost", "Material Cost",
                            "Qty Inv", "Inv Amt", "Cogs", "Total Material Cost", "Etd", "Hawb", "Airway Bill", "So Number", "Do Number",
                            "Cust Code", "Inv Amt (Forr)", "Sbu Code"
                        ];

const keyMap = [
    "customer_name",      // Cust Name
    "ship_to",            // Ship To
    "freight_term",       // Freight Term
    "invoice_number",     // Inv No
    "invoice_date",       // Inv Date
    "OrderType",          // Order Type
    "Country",            // Country
    "CustomerGroup",      // Customer Group
    "model",              // Sub Group
    "item_type",          // Item Type
    "category_code",      // Category
    "category",           // Item Cat
    "part_number",        // Item No
    "invoice_currency_code", // Curr
    "unit_selling_price", // Sell Price
    "UnitPrice",          // Unit Price
    "UnitCost",           // Unit Cost
    "MaterialCost",       // Material Cost
    "quantity_invoiced",  // Qty Inv
    "invoice_amount",     // Inv Amt
    "cogs",               // Cogs
    "total_material_cost",// Total Material Cost
    "etd_sin",            // Etd
    "hawb",               // Hawb
    "AirwayBill",         // Airway Bill
    "SoNumber",           // So Number
    "DoNumber",           // Do Number
    "CustCode",           // Cust Code
    "InvAmtForr",         // Inv Amt (Forr)
    "SbuCode"             // Sbu Code
];

            // Prepare data for export (convert number columns to numbers)
const numberCols = [
    "Sell Price", "Unit Price", "Unit Cost", "Qty Inv", "Inv Amt", "Material Cost", "Inv Amt (Forr)","Cogs","Total Material Cost",
];
const numberColIndexes = numberCols.map(header => excelHeaders.indexOf(header));

// Prepare data for export, converting number columns to numbers
const exportData = allData.map(row =>
    keyMap.map((key, idx) => {
        let value = row[key] !== undefined ? row[key] : "";
        if (numberColIndexes.includes(idx)) {
            // Remove commas before converting to number
            const num = Number(String(value).replace(/,/g, ""));
            return value !== undefined && value !== null && value !== "" && !isNaN(num) ? num : "";
        }
        return value !== undefined && value !== null ? value : "";
    })
);

// Convert to worksheet with custom headers
const worksheet = XLSX.utils.aoa_to_sheet([excelHeaders, ...exportData]);

// Set cell type to number for these columns
numberColIndexes.forEach(colIdx => {
    exportData.forEach((row, rowIdx) => {
        const cellRef = XLSX.utils.encode_cell({ c: colIdx, r: rowIdx + 1 }); // +1 for header row
        const value = row[colIdx];
        if (worksheet[cellRef] && typeof value === "number" && !isNaN(value)) {
            worksheet[cellRef].t = "n";
            worksheet[cellRef].z = "#,##0.00"; // Optional: Excel number format
        }
    });
});

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Actual Sales");
            XLSX.writeFile(workbook, "ActualSalesData.xlsx");
            toast.success("Data exported successfully!");
        } catch (error) {
            console.error("Error exporting data:", error);
            alert("Failed to export data. Please try again.");
        }
    };
    return (
        <div className="bg-white p-4">
            <div className="flex items-center space-x-4 mb-4">
                <div className="md:w-1/4 w-full flex flex-col">
                    <label className="mb-2 text-[#000] font-bold">Date Range</label>
                    <RangePicker
                        format="DD/MM/YYYY"
                        onChange={handleDateRangeChange}
                        className="border border-gray-300 p-5 rounded-md w-full"
                        value={dates}
                        size="large"
                    />
                </div>
                <div className="md:w-1/4 w-full flex items-center mt-6">
                    <label className="mb-2 block text-sm  invisible ">
                        Search
                    </label>
                    <button className="bg-[#3D3D3D] w-full h-10 rounded-md cursor-pointer"  onClick={handleSearch}>
                        <span className="text-white" >Search</span>
                    </button>
                </div>
                  <div className="ml-auto flex gap-x-5 justify-end py-1 "  >
                {/* Import Button with icon */}
                <button className="bg-[#287DD1] text-white px-6 py-3 rounded-md flex items-center gap-x-2 cursor-pointer" onClick={() => navigate("/upload-actual-excel")}>
                    <FaUpload className="text-white" /> {/* Upload icon */}
                    <span className="text-white">Import</span>
                </button>

                {/* Export Button with icon */}
                <button className="bg-[#107C41] text-white px-6 py-3 rounded-md flex items-center gap-x-2  cursor-pointer" onClick={handleExport}>
                    <FaDownload className="text-white" /> {/* Download icon */}
                    <span className="text-white">Export</span>
                </button>
            </div>
            </div>
          
            {/* Table Section */}
            {loading ? (
                <div>
                    {/* <Spinner /> */}
                </div>) : filteredData.length === 0 ? (
                    <div className="text-center text-gray-500 py-4">
                        No Records Found
                    </div>
                ): (<div className="table-container  bg-white shadow-md ">
                    <table className="min-w-max w-full  text-sm border border-[#D5D5D5] table-fixed">
                        <thead className="bg-[#F5F7FF] sticky top-0 z-10">
                            <tr>
                                {columns.map((col) => (
                                    <th
                                       style={{
                                            minWidth: col.width,
                                            maxWidth: col.width,
                                            position: col.frozen ? "sticky" : "static",
                                            left: col.frozen ? frozenLeftMap[col.dataIndex] : "auto",
                                            zIndex: col.frozen ? 4 : 1,
                                            background: "#F5F7FF"
                                        }}
                                        key={col.dataIndex}
                                        className={` text-sm text-center border-r border-[#E5E7EB] py-2 font-semibold    ${
                                                    col.wrap ? "whitespace-normal break-words" : "whitespace-nowrap"
                                                    }`}
                                    >
                                        {col.title}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody >
                            {filteredData.map((row) => (
                                <tr
                                    key={row.id}
                                    className="border-b hover:bg-[#F5F7FF] border-b border-[#D5D5D5]"
                                >
                                    {columns.map((col) => (
                                        <td
                                             style={{
                                                        minWidth: col.width,
                                                        maxWidth: col.width,
                                                        position: col.frozen ? "sticky" : "static",
                                                        left: col.frozen ? frozenLeftMap[col.dataIndex] : "auto",
                                                        zIndex: col.frozen ? 2 : 1,
                                                        background: col.frozen ? "#fff" : "transparent"
                                                    }}
                                            key={col.dataIndex}
                                          className={`text-sm text-center py-2 border-r border-[#E5E7EB] text-black align-top ${
                                                    col.wrap ? "whitespace-normal break-words" : "whitespace-nowrap"
                                                    }`}

                                        >
                                            {col.dataIndex === "part_number" ? (
                                                <div className="tooltip-container">
                                                    <span className="truncate-text">
                                                    {row[col.dataIndex]}
                                                    </span>
                                                    <span className="tooltip-text">
                                                    {row[col.dataIndex]}
                                                    </span>
                                                </div>
                                                ) : col.dataIndex === "action" ? (
                                                col.render(undefined, row)
                                                ) : (
                                                <EditableCell
                                                    record={row}
                                                    columnKey={col.dataIndex}
                                                />
                                                )}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>)
            }
            {total > 10 && (
         <div className="mt-4 flex justify-end">
                <Pagination
                    current={currentPage}
                    pageSize={pageSize}
                    total={total}
                    onChange={handlePageChange}
                    showSizeChanger
                    pageSizeOptions={['100', '500', '1000']}
                />
            </div>
)}
        </div>
    );
};

export default ActualSales;
